module.exports = __webpack_public_path__ + "images/email/bg-active-2-e9d00384452edf638bd86e13c30c8987.png";